import { getDownstreamHostsValue } from "@swiggy-private/checkout-core";

export const getConfigValue = (key: string, fallback: string) => {
    const value = getDownstreamHostsValue(key);
    return value && value !== "undefined" && value !== "null" ? value : fallback;
};

export const DOWNSTREAM_ENDPOINTS = {
    APAY_PUBLIC_VALIDATE_TRANSACTION: "/api/callback/v1/amazonpay/validateTransaction",
    DO_PLACE_ORDER: "/api/v1/checkout/order",
    DO_CONFIRM_ORDER: "/api/v1/dash/oms/poll/order/{0}/context/ORDER_JOB",
    CHECK_OFFER_AND_REWARD_ON_NEW_CARD: "/api/v1/payment/reward/offer/newCard",
};

export const DOWNSTREAM_HOSTS = {
    PAYMENT_PRESENTATION_SERVICE_HOST:
        getDownstreamHostsValue("PAYMENT_PRESENTATION_SERVICE_HOST") ?? "https://chkout.swiggy.com",
    DO_HOST: getDownstreamHostsValue("DO_HOST") ?? "https://dinersone-proxy.swiggy.com",
    USER_SERVICE_HOST: getConfigValue("USER_SERVICE_HOST", "https://profile.swiggy.com"),
    PAYMENT_RETURN_URL: getConfigValue("PAYMENT_RETURN_URL", "https://payments.swiggy.com/checkout/order-received"),
    API_HOST: getConfigValue("API_HOST", "https://payments.swiggy.com"),
    CHECKOUT_READ_HOST: getConfigValue("CHECKOUT_READ_HOST", "https://chkout.swiggy.com"),
    PARTNER_REWARDS_HOST: getDownstreamHostsValue("PARTNER_REWARDS_HOST") ?? "https://spns.swiggy.com",
    CBCC_API_HOST: getDownstreamHostsValue("CBCC_API_HOST") ?? "https://cbcc.swiggy.com",
};

export const PAYMENT_CONFIG = {
    MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW: getConfigValue(
        "MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW",
        "1034",
    ),
    MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW: getConfigValue("MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW", "420"),
    MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API: getConfigValue(
        "MIN_ANDROID_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API",
        "1515",
    ),
    MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API: getConfigValue(
        "MIN_IOS_VERSION_FOR_PAYMENT_PENDING_FLOW_PUBLIC_API",
        "665",
    ),
    USE_NEW_PAYMENT_ENDPOINT: getConfigValue("USE_NEW_PAYMENT_ENDPOINT", "false"),
    REGISTER_PAY_ON_DELIVERY_PUBLIC: getConfigValue("REGISTER_PAY_ON_DELIVERY_PUBLIC", "false"),
    PORTAL_HELP_FILE_UPLOAD_URL: getConfigValue("PORTAL_HELP_FILE_UPLOAD_URL", "https://www.swiggy.com"),
    PORTAL_HELP_FILE_UPLOAD_BUCKET: getConfigValue("PORTAL_HELP_FILE_UPLOAD_BUCKET", "dineout-rx-bills"),
    SWIGGY_WEBVIEW_URL_PREFIX: getConfigValue("SWIGGY_WEBVIEW_URL_PREFIX", "swiggy://webviewV2?webview_url"),
    STEAL_STORE_MY_VOUCHERS_URL: getConfigValue("STEAL_STORE_MY_VOUCHERS_URL", "https://webviews.swiggy.com/my-account/steal-store/my-vouchers/"),
};
